import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { ReactComponent as StepComplete } from '../../assets/images/step-complete.svg';
import { ReactComponent as StepIcon } from '../../assets/images/step-icon.svg';
import { ReactComponent as StepIconCurrent } from '../../assets/images/step-icon-current.svg';
import { useReferralFlowContext } from '../../contexts/ReferralFlowContext';

import styles from './ReferralFlowStepper.module.scss';

export const ReferralFlowStepper = ({ currentStep }) => {
  const { t } = useTranslation('referral');
  const { strengthenQuestions } = useReferralFlowContext();

  const steps = strengthenQuestions.enable_referral_questions
    ? [
        { id: 'yourInfo', label: t('stepper.yourInfo'), description: t('stepper.yourInfoDesc') },
        { id: 'candidateInfo', label: t('stepper.candidateInfo'), description: t('stepper.candidateInfoDesc') },
        { id: 'companyOpening', label: t('stepper.companyOpening'), description: t('stepper.companyOpeningDesc') },
        { id: 'reviewSend', label: t('stepper.reviewSend'), description: t('stepper.reviewSendDesc') },
        {
          id: 'strengthen',
          label: t('stepper.strengthenReferrals'),
          description: t('stepper.strengthenReferralsDesc'),
        },
      ]
    : [
        { id: 'yourInfo', label: t('stepper.yourInfo'), description: t('stepper.yourInfoDesc') },
        { id: 'candidateInfo', label: t('stepper.candidateInfo'), description: t('stepper.candidateInfoDesc') },
        { id: 'companyOpening', label: t('stepper.companyOpening'), description: t('stepper.companyOpeningDesc') },
        { id: 'reviewSend', label: t('stepper.reviewSend'), description: t('stepper.reviewSendDesc') },
      ];

  return (
    <div className={styles.stepsSidebar}>
      {steps.map((step, index) => (
        <div
          key={step.id}
          className={classNames(
            styles.step,
            currentStep === index + 1 && styles.stepActive,
            currentStep > index + 1 && styles.stepCompleted
          )}
        >
          <div className={styles.stepLineContainer}>
            {currentStep > index + 1 ? <StepComplete /> : null}
            {currentStep === index + 1 ? <StepIconCurrent className={styles.stepIconCurrent} /> : null}
            {currentStep < index + 1 ? <StepIcon /> : null}
            {index !== steps.length - 1 && <div className={styles.stepLine} />}
          </div>
          <div className={styles.stepContent}>
            <p className={styles.stepLabel}>{step.label}</p>
            <p className={styles.stepDescription}>{step.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
